import { ClientLauncherApp, startClient } from '@axa-fr-axion/client-launcher';
import { configureLogger } from '@axa-fr-axion/log';
import { AppOptions, AppProps } from 'App.interface';
import { NavigationPath } from 'interfaces';
import { StartOptions } from 'msw';
import { StrictMode } from 'react';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './variables.css';

const name = process.env.REACT_APP_NAME || '';
const version = process.env.REACT_APP_VERSION || '';

const workerOptions: StartOptions = {
    serviceWorker: {
        url: `${ window?.location?.pathname || '' }mockServiceWorker.js`,
    },
};

(async function () {
    // Polyfill for crypto.randomUUID
    // Available in Chrome >= 92, but necessary for AXA tests' VMs which use old versions of browsers
    // Loaded only if necessary and with a lazy import to force chunkization
    if (!window.crypto?.randomUUID) {
        await import('randomuuid');
    }

    let onScenarioChange: AppProps['onScenarioChange'];
    let path: NavigationPath | undefined;

    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MOCK_ENABLED === 'true') {
        const { applyScenario, worker } = await import('mocks/browser');
        if (worker) {
            worker.start(workerOptions);
            onScenarioChange = applyScenario;
            path = 'Scenarios';
        }
    }

    const launcher: ClientLauncherApp<AppOptions> = async (defaultOptions) => {
        let options = defaultOptions;
        if (options?.config?.isMockEnabled) {
            const { applyScenario, worker } = await import('mocks/browser');
            if (worker) {
                worker.start(workerOptions);
                onScenarioChange = applyScenario;
                path = 'Scenarios';
            }

            // If mock enabled, default log level to 'debug'
            if (!options?.config?.logLevel) {
                options = {
                    ...options,
                    config: {
                        ...options.config,
                        logLevel: 'debug',
                    },
                };
            }
        }
        configureLogger(options?.config?.logLevel);

        return (
            <StrictMode>
                <App
                    onScenarioChange={ onScenarioChange }
                    options={ options }
                    path={ path }
                />
            </StrictMode>
        );
    };

    startClient(launcher, { name, version });

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
})();
